import { render, staticRenderFns } from "./SendMessageActionsWarning.vue?vue&type=template&id=3583ded0&"
import script from "./SendMessageActionsWarning.vue?vue&type=script&lang=ts&"
export * from "./SendMessageActionsWarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports